import type { CampaignFilter } from "@campaign/domain/models/campaign.model";
import type { Nullable } from "@core/domain/types/nullable.type";
import { BaseViewModel } from "@iot-platform/core";
import { injectable } from "inversify";
import { action, makeObservable, observable } from "mobx";
@injectable()
export class CampaignFilterViewmodel extends BaseViewModel {
    @observable
    stationId: Nullable<string> = null;

    @observable
    date: Nullable<string> = null;

    @observable
    filters: CampaignFilter = {};

    constructor() {
        super();
        makeObservable(this);
    }

    @action
    setFilters(updatedFilters: Partial<CampaignFilter>): void {
        this.filters = { ...this.filters, ...updatedFilters };
    }

    @action
    getFilters(): CampaignFilter {
        return {
            name: this.filters.name,
            stationId: this.filters.stationId,
            cropTypeId: this.filters.cropTypeId,
            date: this.filters.date,
        };
    }
}
